import { render } from "./Init.vue?vue&type=template&id=16b306a6&scoped=true"
import script from "./Init.vue?vue&type=script&lang=js"
export * from "./Init.vue?vue&type=script&lang=js"

import "./Init.vue?vue&type=style&index=0&id=16b306a6&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16b306a6"]])

export default __exports__